import ErrorsManager from './ErrorsManager';
import { ADAPTOR_ERROR } from './Error';

/**
 * Custom Error class for Adapter failures.
 * Note: This class uses a factory pattern in the constructor.
 */
class AdapterError extends Error {
    constructor(error: any, messageCustom?: string) {
        // Call super to satisfy the Error base class
        super(error instanceof Error ? error.message : String(error));

        // Standard TS/JS practice for custom errors to maintain stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdapterError);
        }

        /**
         * The original JS implementation returns the result of createError.
         * In TS, we cast this to 'any' or the specific Error interface
         * because constructors typically return 'this' implicitly.
         */
        return ErrorsManager.createError({
            type: ADAPTOR_ERROR,
            error,
            messageCustom,
        }) as any;
    }
}

export default AdapterError;
